export const numberFormat = (num: number | string, toFixed = 0, emptyChar?: any[]) => {
  if (isNaN(Number(num)) || num === "" || emptyChar?.includes(num)) {
    return "-";
  }
  const fixedNum = Number(num).toFixed(toFixed);
  return fixedNum.toString().replace(/\d+/, function (n: any) {
    return n.replace(/(\d)(?=(\d{3})+(\.|$))/g, function ($1: any) {
      return $1 + ",";
    });
  });
};
export const priceFormat = (num: number | string, toFixed = 2, unit = "￥") => {
  return `${unit}${numberFormat(num, toFixed) || "-"}`;
};
export const percentFormat = (num: number | string, toFixed = 2) => {
  if (isNaN(Number(num))) {
    return "";
  }
  return `${numberFormat(Number(num) * 100, toFixed)}%`;
};
export const filterZero = (num: number | string) => {
  if (isNaN(Number(num)) || Number(num) === 0) {
    return "";
  }
  return num;
};

export function getDecimalNumber (num: number | string) {
  const numStr = num?.toString() || "";
  const decimalIndex = numStr?.indexOf(".");
  return decimalIndex === -1 ? 0 : numStr.length - decimalIndex - 1;
}

export function cutZero (num: number | string) {
  const numStr = num?.toString() || "";
  const decimalIndex = numStr?.indexOf(".");
  if (decimalIndex === -1) {
    return numStr;
  }
  const decimalPart = numStr.slice(decimalIndex);
  const decimalPartWithoutZero = decimalPart.replace(/0+$/, "");
  if (decimalPartWithoutZero === ".") {
    return numStr.slice(0, decimalIndex);
  }
  if (decimalPartWithoutZero.length < decimalPart.length) {
    return numStr.slice(0, decimalIndex + decimalPartWithoutZero.length);
  }
  return numStr;
}
